module.exports = __webpack_public_path__ + "static/49-seat-coach-hire-c92762380a247b2ebef3699ba3e61d81.jpg";